/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
import { StringTableCommon } from './common/StringTableCommon'
import { StringTableCatalog } from './common/components/catalog/StringTableCatalog'
import { StringTableBlog } from './common/components/blog/StringTableBlog'
export const StringTable = [
  ...StringTableCommon,
  ...StringTableCatalog,
  ...StringTableBlog,
  {
    "key": "sampleStrKey",
    "en": "Sample"
  },
  {
    "key": "orgs",
    "en": "Tenants"
  },
  {
    "key": "ctaButtonLabel",
    "en": "Manage"
  },
  {
    "key": "settingsMaster",
    "en": "Master Settings"
  },
  {
    "key": "welcome",
    "en": "Login"
  },
  {
    "key": "email",
    "en": "Admin/Staff Email"
  },
  {
    "key": "terms&Conditions",
    "en": "Terms & conditions"
  },
  {
    "key": "knowAbout",
    "en": "Know more about"
  },
  {
    "key": "knowAboutSlixta",
    "en": "Know more about Slixta"
  },
  {
    "key": "adminBannerTitle",
    "en": "Slixta"
  },
  {
    "key": "adminBannerDesc",
    "en": "Unified content, commerce, and data platform that helps brands offer better digital experiences for the online audience"
  },
  {
    "key": "getStarted",
    "en": "Get started"
  },
  {
    "key": "statsInfo",
    "en": "Stats info"
  },
  {
    "key": "quickLinks",
    "en": "Quick links"
  },
  {
    "key": "adminBannerAlt",
    "en": "Banner for dashboard"
  },
  {
    "key": "statsIconsAlt",
    "en": "Icon for stats"
  },
  {
    "key": "contactBannerTitle",
    "en": "Need help?"
  },
  {
    "key": "handClickImgAlt",
    "en": "Contact us"
  },
  {
    "key": "loadingText",
    "en": "Loading..."
  },
  {
    "key": "cbdeffields",
    "en": "Fields"
  },
  {
    "key": "cbdeffieldscommon",
    "en": "Fields Common"
  },
  {
    "key": "emailcbdeffields",
    "en": "Email Fields"
  },
  {
    "key": "cbdefs",
    "en": "Custom Defined Widgets"
  },
  {
    "key": "emailcbdefs",
    "en": "Email Widgets"
  },
  {
    "key": "cbdats",
    "en": "Data for Widget"
  },
  {
    "key": "emailcbdats",
    "en": "Data for Widget"
  },
  {
    "key": "contactUsForSupport",
    "en": "Contact us for support"
  },
  {
    "key": "pagecbs",
    "en": "Page Widgets"
  },
  {
    "key": "emailpagecbs",
    "en": "Email Page Widgets"
  },
  {
    "key": "cotypeblocks",
    "en": "Subpage"
  },
  {
    "key": "cborgs",
    "en": "Reusable Widgets"
  },
  {
    "key": "globalBlocks",
    "en": "Widget Lib"
  },
  {
    "key": "globalBlocksTags",
    "en": "Widget Tags"
  },
  {
    "key": "emailglobalBlocks",
    "en": "Email Widget Lib"
  },
  {
    "key": "blocks",
    "en": "Widgets"
  },
  {
    "key": "blocks-widgets",
    "en": "Widgets"
  },
  {
    "key": "cotypeblocks-widgets",
    "en": "Subpage"
  },
  {
    "key":"createcopy",
    "en": "Create a copy"
  },
  {
    "key": "assets",
    "en": "Assets"
  },
  {
    "key": "pages",
    "en": "Pages"
  },
  {
    "key": "site",
    "en": "Site"
  },
  {
    "key": "emailpages",
    "en": "Email Templates"
  },
  {
    "key": "menus",
    "en": "Header"
  },
  {
    "key": "menusl2",
    "en": "Menu Level 2"
  },
  {
    "key": "menusl3",
    "en": "Menu Level 3"
  },
  {
    "key": "footernav",
    "en": "Footer"
  },
  {
    "key": "footernavl2",
    "en": "Sub Nav"
  },
  {
    "key": "orgSwitcher",
    "en": "Org switcher"
  },
  {
    "key": "selectOrg",
    "en": "Select org"
  },
  {
    "key": "uploadFile",
    "en": "Drag & Drop a file here or"
  },
  {
    "key": "blockSelection",
    "en": "Select a widget"
  },
  {
    "key": "emailblockSelection",
    "en": "Select an email widget"
  },
  {
    "key": "ecom",
    "en": "Commerce"
  },
  {
    "key": "settingsbranding",
    "en": "Branding"
  },
  {
    "key": "nav",
    "en": "Navigation"
  },
  {
    "key": "editOrDelete",
    "en": "Edit/Delete"
  },
  {
    "key": "uploadHotspotImage",
    "en": "Upload the image on which you want to add hotspots"
  },
  {
    "key": "bannerImageAlt",
    "en": "Banner Image"
  },
  {
    "key": "cotypes",
    "en": "Custom Objects"
  },
  {
    "key": "cos",
    "en": "Data"
  },
  {
    "key": "cosl2",
    "en": "Nested Data"
  },
  {
    "key": "content",
    "en": "Content",
  },
  {
    "key": "content-types-short",
    "en": "Types",
  },
  {
    "key": "content-types",
    "en": "Content Types",
  },
  {
    "key": "content-fragments",
    "en": "Content Fragments",
  },
  {
    "key": "content-personas-short",
    "en": "Personas",
  },
  {
    "key": "content-personas",
    "en": "User Personas",
  },
  {
    "key": "content-inputs-short",
    "en": "Inputs",
  },
  {
    "key": "content-inputs",
    "en": "Content Inputs",
  },
  {
    "key": "content-outputs-short",
    "en": "Outputs",
  },
  {
    "key": "content-outputs",
    "en": "Content Outputs",
  },
  {
    "key": "content-generator-short",
    "en": "Generator",
  },
  {
    "key": "content-generator",
    "en": "Content Generator",
  },
  {
    "key": "content-cluster-blogs",
    "en": "Content Cluster Blogs",
  },
  {
    "key": "content-blog-generator",
    "en": "Blog Generator",
  },
  {
    "key": "content-planner",
    "en": "Content Planner",
  },
  {
    "key": "content-cluster-titles",
    "en": "Cluster Titles",
  },
  {
    "key": "ai-content",
    "en": "AI Content",
  },
  {
    "key": "campaigns",
    "en": "Campaigns",
  },
  {
    "key": "campaignresult",
    "en": "Results",
  },
  {
    "key": "journeys",
    "en": "Journeys",
  },
  {
    "key": "journeyresult",
    "en": "Results",
  },
  {
    "key": "crm",
    "en": "CRM",
  },
  {
    "key": "crm-contacts",
    "en": "Contacts",
  },
  {
    "key": "crm-contacts-legacy",
    "en": "Contacts [legacy]",
  },
  {
    "key": "crm-contact",
    "en": "Contact",
  },
  {
    "key": "crm-contacts-custom-fields",
    "en": "Contact Custom Fields",
  },
  {
    "key": "crm-accounts",
    "en": "Accounts",
  },
  {
    "key": "crm-account",
    "en": "Account",
  },
  {
    "key": "crm-accounts-custom-fields",
    "en": "Account Custom Fields"
  },
  {
    "key": "crm-teams",
    "en": "Teams",
  },
  {
    "key": "teams",
    "en": "Teams",
  },
  {
    "key": "staff",
    "en": "Staff",
  },
  {
    "key": "teams-fields",
    "en": "Org Custom Fields",
  },
  {
    "key": "org-custom-fields",
    "en": "Org Custom Fields",
  },
  {
    "key": "oneview",
    "en": "Oneview",
  },
  {
    "key": "emailpageslib",
    "en": "Email Templates",
  },
  {
    "key": "segments",
    "en": "Segments",
  },
  {
    "key": "cdp-settings",
    "en": "CDP Settings",
  },
  {
    "key": "crm-settings",
    "en": "Settings",
  },
  {
    "key": "crm-inboxes",
    "en": "Inboxes",
  },
  {
    "key": "crm-inbox",
    "en": "Inbox",
  },
  {
    "key": "crm-user-settings",
    "en": "User Settings",
  },
  {
    "key": "crm-email-templates",
    "en": "CRM Email Templates",
  },
  {
    "key": "crm-email-templates-short",
    "en": "Templates",
  },
  {
    "key": "whatsapp-menu",
    "en": "WhatsApp",
  },
  {
    "key": "whatsapp-templates",
    "en": "Templates",
  },
  {
    "key": "whatsapp-flows",
    "en": "Flows",
  },
  {
    "key": "whatsapp-messages",
    "en": "Messages",
  },
  {
    "key": "whatsapp-chatbots",
    "en": "Chatbots",
  },
  {
    "key":"whatsapp-numbers",
    "en": "Numbers",
  },
  {
    "key": "automations",
    "en": "Automations",
  },
  {
    "key": "workflows",
    "en": "Workflows",
  },
  {
    "key": "automation-journeys",
    "en": "Automation Journeys",
  },
  {
    "key": "crm-sequences",
    "en": "Sequences",
  },
  {
    "key": "crm-sequence-steps",
    "en": "Steps",
  },
  {
    "key": "crm-sequence-enrolments",
    "en": "Enrolments",
  },
  {
    "key": "embed-tags",
    "en": "Embed Tags",
  },
  {
    "key": "ooh",
    "en": "OOH",
  },
  {
    "key": "broadcasts",
    "en": "Broadcasts",
  },
  {
    "key": "transactional",
    "en": "Transactional",
  },
  {
    "key": "notifications",
    "en": "Notifications",
  },
  {
    "key": "popups",
    "en": "Popups",
  },
  {
    "key": "reusableData",
    "en": "Data for Widget (Shared)",
  },
  {
    "key": "popup-analytics",
    "en": "Popup Analytics",
  },
  {
    "key": "jobs",
    "en": "Jobs",
  },
  {
    "key": "backToWidgets",
    "en": "Back to Widgets"
  },
  {
    "key": "backToPage",
    "en": "Back to Page"
  },
  {
    "key": "backToPages",
    "en": "Back to All Pages"
  },
  {
    "key": "backToDashboard",
    "en": "Back to Dashboard"
  },
  {
    "key": "backToSubPage",
    "en": "Back to Subpage"
  },
  {
    "key": "backToCRM",
    "en": "Back to CRM"
  },
  {
    "key": "backToBroadcasts",
    "en": "Back to Broadcasts"
  },
  {
    "key": "backToSequences",
    "en": "Back to Sequences"
  },
  {
    "key": "pageDetails",
    "en": "Details"
  },
  {
    "key": "backToAutomations",
    "en": "Back to Automations"
  },
  {
    "key": "backToTeams",
    "en": "Back to Teams"
  },
  {
    "key": "sharedWidget",
    "en": "Shared Widget"
  },
  {
    "key": "sharedWidgetInfo",
    "en": "Changes to this widget will have effect on all pages where this widget is used"
  },
  {
    "key": "widgetSearchHint",
    "en": "Search by Widget Name / Section Title"
  },
  {
    "key": "orgSearchHint",
    "en": "Search by Tenant Name / Tenant Id"
  },
  {
    "key": "editPage",
    "en": "Edit Page"
  },
  {
    "key": "advancedPageSettings",
    "en": "Advanced Page Settings"
  },
  {
    "key": "pageSeo",
    "en": "Page SEO"
  },
  {
    "key": "previewPage",
    "en": "Preview Page"
  },
  {
    "key": "previewWidget",
    "en": "Preview Widget"
  },
  {
    "key": "pageSearchHint",
    "en": "Search by Page Title / Slug"
  },
  {
    "key": "clonePage",
    "en": "Clone Page"
  },
  {
    "key": "advanced",
    "en": "Advanced"
  },
  {
    "key": "quickfill",
    "en": "Quick Fill"
  },
  {
    "key": "commonWidgetSearchHint",
    "en": "Search by Widget Name"
  },
  {
    "key": "enrolments",
    "en": "Enrolments"
  },
  {
    "key": "reportsNotConfigured",
    "en": "Reports not configured"
  },
  {
    "key": "reportsOrg",
    "en": "Reports"
  },
  {
    "key": "adsReportOrg",
    "en": "Ads"
  },
  {
    "key": "adsReportNotAvailable",
    "en": "Ads report is not available. Please try again later or contact Slixta support."
  },
  {
    "key": "staffActivityReportNotAvailable",
    "en": "Staff activity report is not available. Please try again later or contact Slixta support."
  },
  {
    "key": "adsReportIsEmpty",
    "en": "There are no active campaigns or ad spends for the selected time period."
  },
  {
    "key": "adsAccountConfigurationNotFound",
    "en": "Ad account is not configured. Please contact Slixta support."
  },
  {
    "key": "adsAccountNotConfigured",
    "en": "Ad account is not configured. Please choose a different ad account or contact Slixta support."
  },
  {
    "key": "unableToConnectLinkedInAdAccount",
    "en": "Unable to connect LinkedIn Ad account. Please try again later or contact Slixta support."
  },
  {
    "key": "unableToGenerateAdReport",
    "en": "Unable to generate Ad report. Please contact Slixta support."
  },
  {
    "key": "menu",
    "en": "Menu"
  },
  {
    "key": "visitors",
    "en": "Visitors"
  },
  {
    "key": "leads",
    "en": "Leads"
  },
  {
    "key": "slixtaTagLine",
    "en": "An All-in-one Marketing Suite"
  },
  {
    "key": "addContact",
    "en": "Add Contact"
  },
  {
    "key": "editContact",
    "en": "Edit Contact"
  },
  {
    "key": "prospectContacts",
    "en": "Prospect Contacts"
  },
  {
    "key": "importContacts",
    "en": "Import Contacts"
  },
  {
    "key": "exportContacts",
    "en": "Export Contacts"
  },
  {
    "key": "exportAccounts",
    "en": "Export Accounts"
  },
  {
    "key": "exportAdReport",
    "en": "Export Ad Report"
  },
  {
    "key": "exportStaffActivity",
    "en": "Export Staff Activity"
  },
  {
    "key": "exportActivity",
    "en": "Export Activity"
  },
  {
    "key": "exportSummary",
    "en": "Export Summary"
  },
  {
    "key": "addAccount",
    "en": "Add Account"
  },
  {
    "key": "editAccount",
    "en": "Edit Account"
  },
  {
    "key": "importAccounts",
    "en": "Import Accounts"
  },
  {
    "key": "googleAnalyticsPropertyError",
    "en": "Your analytics is not correctly configured. Contact Slixta support."
  },
  {
    "key": "reportNotFound",
    "en": "Report is not available"
  },
  {
    "key": "viewRecordings",
    "en": "View Recordings"
  },
  {
    "key": "suborgs",
    "en": "Teams"
  },
  {
    "key": "commonWidgetSettings",
    "en": "Widget Common Settings"
  },
  {
    "key": "widgetData",
    "en": "Widget Data"
  },
  {
    "key": "configButton",
    "en": "Configure Button"
  },
  {
    "key": "confNavLink",
    "en": "Configure Navigation Link"
  },
  {
    "key": "accounts",
    "en": "Accounts"
  },
  {
    "key": "sectionIntro",
    "en": "The optional section title & subtitle will appear right above this widget on the page. This is helpful to add headings between two widgets."
  },
  {
    "key": "sectionDetails",
    "en": "Section Details"
  },
  {
    "key": "numberRangeErr",
    "en": "Start value cannot exceed end value"
  },
  {
    "key": "numberFieldStartTypeError",
    "en": "Start value must be a number"
  },
  {
    "key": "numberFieldEndTypeError",
    "en": "End value must be a number"
  },
  {
    "key": "numberFieldTypeError",
    "en": "Start and end values must be numbers"
  },
  {
    "key": "setYourPassword",
    "en": "Set your Password"
  },
  {
    "key": "sendWhatsAppMessage",
    "en": "Contact will get a Whatsapp message."
  },
  {
    "key": "enrichCreditsBalanceNotice",
    "en": "This feature uses credits from your balance."
  },
  {
    "key": "enrichCreditsLearnMore",
    "en": "Learn more"
  },
  {
    "key": "accountEnrichFieldsList",
    "en": "Company name, Website, Industry, Employee count, Country/City, Company LinkedIn URL etc"
  },
  {
    "key": "sendTemplateMessage",
    "en": "Send Template Message"
  },
  {
    "key": "sendQuickMessage",
    "en": "Send Quick Message"
  },
  {
    "key": "onlyWAInteractions",
    "en": "After 24 hours of customer inactivity, WhatsApp allows only template messages (free-form text typing is not allowed)."
  },
  {
    "key":"differentOutgoingNumberWAInteraction",
    "en":"The last message from lead is within 24 hrs but was sent to an alternate connected WhatsApp number. WhatsApp allows only template messages (free-form text typing is not allowed)."
  },
  {
    "key": "tooManyRequests",
    "en": "Too Many Requests"
  },
  {
    "key": "whatsAppUnavailableForContact",
    "en": "No phone number found for this contact. WhatsApp isn’t available."
  },
  {
    "key": "waMarketingDeliveryWarning",
    "en": "WhatsApp may drop some marketing template messages based on recipient engagement and delivery policies."
  },
  {
    "key": "provideInteraction",
    "en": "Provide interaction"
  },
  {
    "key": "provideWaSendType",
    "en": "Provide type"
  },
  {
    "key": "provideWaMessage",
    "en": "Provide message"
  },
  {
    "key": "waSendMissingContactValues",
    "en": "Contact is missing values required by this message."
  },
  {
    "key": "waPreviewNotAvailable",
    "en": "Preview is not available"
  },
  {
    "key": "waPreviewPickMessage",
    "en": "Pick a message to preview and send"
  },
  {
    "key": "staff-activity",
    "en": "Interactions"
  },
  {
    "key": "my-activity",
    "en": "My Activity"
  },
  {
    "key": "staff-assignments",
    "en": "Assignments"
  },
  {
    "key": "usage-wallet",
    "en": "Usage Wallet"
  },
  {
    "key": "info",
    "en": "Info"
  },
  {
    "key": "showContactUpdates",
    "en": "Show Contact Updates"
  },
  {
    "key": "showAccountUpdates",
    "en": "Show Account Updates"
  },
  {
    "key": "dataNotAvailable",
    "en": "Data is not available."
  },
  {
    "key": "unableToOpenFile",
    "en": 'Unable to open the file.'
  },
  {
    "key": "ads",
    "en": 'Ads'
  },
  {
    "key": "addStaff",
    "en": "Add Staff"
  },
  {
    "key": "editStaff",
    "en": "Edit Staff"
  },
  {
    "key": "deleteStaff",
    "en": "Delete Staff"
  },
  {
    "key": "staffSearchHint",
    "en": "Search by Staff Name / Email"
  },
  {
    "key": "mainOrgRolesOrTeamsRequiredErrMsg1",
    "en": "Staff must have a main org role."
  },
  {
    "key": "mainOrgRolesOrTeamsRequiredErrMsg2",
    "en": "Staff must either have a main org role or be assigned to a team."
  },
  {
    "key": "customerSuccess",
    "en": "Customer Success"
  },
  {
    "key": "clickToCallNoPhoneNumberErrMsg",
    "en": "The Click-to-call number has to be configured for your staff account. Contact your administrator."
  },
  {
    "key": "zohoInboxes",
    "en": "Zoho Inboxes"
  },
  {
    "key": "zohoDomains",
    "en": "Zoho Domains"
  },
  {
    "key": "zohoInboxesEmpty",
    "en": "No Zoho inboxes found."
  },
  {
    "key": "zohoDomainsEmpty",
    "en": "No Zoho domains found."
  },
  {
    "key": "zohoInboxesSearchHint",
    "en": "Search by email, name, or account"
  },
  {
    "key": "zohoDomainsSearchHint",
    "en": "Search by domain or account"
  },
  {
    "key": "zohoAllAccounts",
    "en": "All Zoho accounts"
  },
  {
    "key": "zohoInboxesDeleteTitle",
    "en": "Delete Zoho Inbox"
  },
  {
    "key": "zohoDomainsDeleteTitle",
    "en": "Delete Zoho Domain"
  },
  {
    "key": "zohoInboxesDeleteWarn",
    "en": "This removes the placement test (if any), Slixta inbox in any org (if any), then the Zoho user. This cannot be undone."
  },
  {
    "key": "zohoDomainsDeleteWarn",
    "en": "This runs AWS domain cleanup then deletes the Zoho domain. This is destructive and cannot be undone."
  },
  {
    "key": "zohoInboxesDeleteSuccess",
    "en": "Zoho inbox deleted successfully."
  },
  {
    "key": "zohoDomainsDeleteSuccess",
    "en": "Zoho domain deleted successfully."
  },
  {
    "key": "zohoViewInboxes",
    "en": "View inboxes"
  },
  {
    "key": "zohoInboxesClearFilter",
    "en": "Show all"
  },
  {
    "key": "zohoInboxesFilteredEmpty",
    "en": "No Zoho inboxes found for this domain."
  },
  {
    "key": "zohoDisableForwarding",
    "en": "Disable forwarding"
  },
  {
    "key": "zohoDisableForwardingTitle",
    "en": "Disable forwarding"
  },
  {
    "key": "zohoDisableForwardingWarn",
    "en": "This disables email forwarding for this Zoho inbox."
  },
  {
    "key": "zohoDisableForwardingSuccess",
    "en": "Forwarding disabled successfully."
  },
]
